import React from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from 'react-query'
import {
  Box,
  Text,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge
} from '@chakra-ui/react'
import { TableBox, Loading, money, get, labels, colors } from './shared'

export const CollectionTable = ({ rows = [], showPeriod = false }) => (
  <TableBox>
    <Table size="sm">
      <Thead>
        <Tr>
          {showPeriod && <Th>Período</Th>}
          <Th>Socio</Th>
          <Th isNumeric>Esperado</Th>
          <Th isNumeric>Cobrado</Th>
          <Th isNumeric>Diferencia</Th>
          <Th>Resultado</Th>
          <Th>Motivo / rango sugerido</Th>
        </Tr>
      </Thead>
      <Tbody>
        {!rows.length && (
          <Tr>
            <Td colSpan={showPeriod ? 7 : 6}>
              No hay registros para esta selección.
            </Td>
          </Tr>
        )}
        {rows.map((row, i) => (
          <Tr key={`${row.period || ''}-${row.rut}-${i}`}>
            {showPeriod && <Td whiteSpace="nowrap">{row.period}</Td>}
            <Td>
              <Text fontWeight="semibold">
                {row.partner ? (
                  <Link to={`/partners/profile/${row.partner}/Perfil de Socio`}>
                    {row.name}
                  </Link>
                ) : (
                  row.name
                )}
              </Text>
              <Text fontSize="xs" color="gray.600">
                {row.rut}
              </Text>
            </Td>
            <Td isNumeric>{money(row.expected)}</Td>
            <Td isNumeric>
              {row.actual ? money(row.actual.amount) : 'Sin respuesta'}
            </Td>
            <Td isNumeric>
              {row.difference == null ? '—' : money(row.difference)}
            </Td>
            <Td>
              <Badge colorScheme={colors[row.status]} whiteSpace="normal">
                {labels[row.status]}
              </Badge>
              {row.actual?.legacy && <Text fontSize="xs">Histórico</Text>}
            </Td>
            <Td>
              <Text fontSize="sm">{row.actual?.reason || '—'}</Text>
              {row.suggestedGrades?.length > 0 && (
                <Text fontSize="xs" color="blue.700">
                  Por monto: {row.suggestedGrades.join(', ')}. Pendiente de
                  confirmar.
                </Text>
              )}
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  </TableBox>
)

export function PartnerBillingHistory({ partnerId }) {
  const query = useQuery(
    ['billing', 'history', partnerId],
    () => get(`history/${partnerId}`),
    { enabled: Boolean(partnerId), retry: false }
  )
  return (
    <Box>
      <Text color="gray.600">
        Comparación mensual y archivos de respuesta. Los descuentos antiguos
        siguen disponibles en la pestaña Descuentos.
      </Text>
      <Loading query={query} />
      <CollectionTable rows={query.data?.history} showPeriod />
      <Heading size="sm" mt={6}>
        Trazabilidad de respuestas
      </Heading>
      <TableBox>
        <Table size="sm">
          <Thead>
            <Tr>
              <Th>Período</Th>
              <Th>Archivo</Th>
              <Th isNumeric>Cobrado</Th>
              <Th>Resultado / corrección</Th>
            </Tr>
          </Thead>
          <Tbody>
            {query.data?.revisions?.map((r) => (
              <Tr key={r._id}>
                <Td>{r.period}</Td>
                <Td>
                  {r.source?.filename}
                  <Text fontSize="xs">
                    {r.source?.appliedAt &&
                      new Date(r.source.appliedAt).toLocaleString('es-CL')}
                  </Text>
                </Td>
                <Td isNumeric>{money(r.amount)}</Td>
                <Td>
                  {r.outcome === 'REJECTED' ? 'No cobrado' : 'Aplicado'}
                  <Text fontSize="xs">
                    {r.reason || r.source?.correctionReason}
                  </Text>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableBox>
    </Box>
  )
}
